export const escapeRegexSpecials = (text: string): string => {
  // eslint-disable-next-line no-useless-escape
  return text.replace(/([\.\\\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:\-])/g, '\\$1')
}
